import React, { Component } from 'react';
import FormInput from './FormInput';
import FormText from './FormText';
import FormSelect from './FormSelect';
import { getTranslation } from '../Utilities/GetTranslation';
import { postContact } from '../Api/UserActions';
import { isEmpty } from '../Utilities/JsonFunctions';

class NamezzzContact extends Component {
    constructor(props) {
        super(props);

        this.state = {
            contactSubject: "",
            contactBody: ""
        };

        this.onChange = this.onChange.bind(this);
        this.submit = this.submit.bind(this);
    }

    onChange(e) {
        this.setState({
            [e.target.id] : e.target.value
        }); 
    }

    submit() {
        if (isEmpty(this.state.contactSubject) && isEmpty(this.state.contactBody)) {
            this.setState({
                showValidation: true
            });
        } else {
            var jobId = (this.state.jobId === -1) ? 0 : this.state.jobId;
            postContact(this.state.contactSubject, this.state.contactBody, jobId, (data) => {
                if (data != null && data.id > 0) {
                    this.setState({
                        contactSubject: "",
                        contactBody: "",
                        jobId: -1
                    });

                    this.props.onSend(data.id);
                }
            });
        }
    }

    render() {
        return (
            <div>
                <FormInput id="contactSubject" 
                    text={getTranslation("sns.webparts.contact.subject")}
                    required={true}
                    showValidation={this.state.showValidation}
                    validationText={isEmpty(this.state.contactSubject) ? getTranslation("basicform.erroremptyvalue"): null}
                    value={this.state.contactSubject} 
                    onChange={this.onChange} />
                <FormText id="contactBody" rows={5}
                    text={getTranslation("sns.webparts.contact.body")} 
                    required={true}
                    showValidation={this.state.showValidation}
                    validationText={isEmpty(this.state.contactBody) ? getTranslation("basicform.erroremptyvalue"): null}                    
                    value={this.state.contactBody}
                    onChange={this.onChange} />
                <FormSelect id="jobId"
                    text={getTranslation("sns.webparts.contact.job")}
                    required={false} 
                    emptyValue={getTranslation("sns.webparts.contact.general")}
                    data={this.props.applications}
                    value={this.state.jobId}
                    onChange={this.onChange} />
                <div className="tr text-right col-md-8 button-wrapper">
                    <input type="button" className="FormButton btn btn-primary blue act" value={getTranslation("sns.webparts.contact.submit")} onClick={this.submit} />
                </div>                      
            </div>
        );
    }
}

export default NamezzzContact;


// WEBPACK FOOTER //
// ./src/Fields/NamezzzContact.js